"use client";

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { useAdmin } from '@/context/AdminContext';
import styles from './NavMembre.module.css';

const onglets = [
  { label: "Profil", href: "/profil" },
];

export default function NavMembre() {
  const { isMemberMode } = useAdmin();
  const pathname = usePathname();

  if (!isMemberMode) return null;

  return (
    <nav className={styles.nav}>
      {onglets.map(o => (
        <Link
          key={o.href}
          href={o.href}
          className={`${styles.onglet} ${pathname.startsWith(o.href) ? styles.actif : ''}`}
        >
          {o.label}
        </Link>
      ))}
    </nav>
  );
}
